var _defs, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCode(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 45,
    height: 36,
    viewBox: "0 0 45 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.277,
    y1: 0.156,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffe0d8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#787cfe"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M-47.378-52.418a2.252,2.252,0,0,0-2.785,1.547l-9,31.493a2.252,2.252,0,0,0,1.547,2.784,2.252,2.252,0,0,0,2.785-1.547l9-31.493A2.252,2.252,0,0,0-47.378-52.418Zm5.668,8.443a2.252,2.252,0,0,0,0,3.184l6.279,6.285-6.286,6.285a2.252,2.252,0,0,0,0,3.184,2.254,2.254,0,0,0,3.185,0l7.876-7.873a2.252,2.252,0,0,0,0-3.184l-7.876-7.873a2.254,2.254,0,0,0-3.185,0Zm-21.567,0a2.254,2.254,0,0,0-3.185,0L-74.338-36.1a2.252,2.252,0,0,0,0,3.184l7.876,7.873a2.254,2.254,0,0,0,3.185,0,2.252,2.252,0,0,0,0-3.184l-6.286-6.278,6.286-6.285A2.252,2.252,0,0,0-63.277-43.975Z",
    transform: "translate(74.997 52.506)",
    fill: "url(#linear-gradient)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCode);
export default __webpack_public_path__ + "static/media/code.5ecd26a631d66208f8a6de576cc5aeef.svg";
export { ForwardRef as ReactComponent };